enum InviteMode {
  Conversion = "Conversion",
  Email = "Email",
}

export default InviteMode;
